enum SubscriptionEventEnum {
    ORDER_CREATE = 'order_create',
    ORDER_UPDATE = 'order_update',
    NEW_ORDER_CREATE = 'new_order_create',
    NEW_ORDER_UPDATE = 'new_order_update',
    EXIT_DECLARATION_CREATE = 'exit-declaration_create',
    EXIT_DECLARATION_UPDATE = 'exit-declaration_update',
    EXIT_DECLARATION_DELETE = 'exit-declaration_delete',
    EXIT_DECLARATION_STATUS = 'exit-declaration_status',
}

function getSubscriptionEvents(): string[] {
    const events = Object.values(SubscriptionEventEnum);

    return events;
}

export { SubscriptionEventEnum, getSubscriptionEvents };
